import { Button, Text } from '@ksyos/design-system';
import { useState } from 'react';
import { ProcessEntity } from '../../../common/enums/processEntity';
import { ServiceType } from '../../../common/enums/serviceType';
import { translateKey } from '../../translate';
import { Modal } from './modals/Modal';

interface IProceedWithoutFilesProps {
    entity: ProcessEntity.request | ProcessEntity.procedure | ProcessEntity.diagnosticReport;
    onNo: () => void | Promise<void>;
    onYes: () => void | Promise<void>;
    serviceType: ServiceType;
}

export function ProceedWithoutFiles(props: IProceedWithoutFilesProps) {
    const [isSaving, setIsSaving] = useState<boolean>(false);

    let entity: string = props.entity;
    if (props.entity === ProcessEntity.request) {
        switch (props.serviceType) {
            case ServiceType.examination:
                entity = 'examinationRequest';
                break;
            case ServiceType.referral:
                entity = 'referral';
                break;
            case ServiceType.referralSmall:
                entity = 'referralSmall';
                break;
            default:
                entity = 'consultationRequest';
        }
    }

    return (
        <Modal
            actionButtons={[
                <Button
                    key="no"
                    onClick={props.onNo}
                    variant="outline"
                >
                    {translateKey('common.no')}
                </Button>,
                <Button
                    className="automation-button"
                    data-automation-test="sendFormWithoutFilesButton"
                    isDisabled={isSaving}
                    key="yes"
                    onClick={async () => {
                        setIsSaving(true);
                        await props.onYes();
                    }}
                >
                    {translateKey('common.yes')}
                </Button>,
            ]}
            isOpen
            onClose={props.onNo}
            size="small"
            title={translateKey('common.sendForm')}
        >
            <Text>{translateKey('request.proceedWithoutFiles', translateKey(`processType.${entity}`))}</Text>
        </Modal>
    );
}
